import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var MinusSquare = createReactComponent("MinusSquare", ["svg", defaultAttributes, [["rect", {
  x: "3",
  y: "3",
  width: "18",
  height: "18",
  rx: "2",
  ry: "2",
  key: "1sylwi"
}], ["line", {
  x1: "8",
  y1: "12",
  x2: "16",
  y2: "12",
  key: "6hnc9b"
}]]]);
export default MinusSquare;